import * as React from 'react';
import { MenuItemLink } from './MenuItemLink';

import * as styles from './menu.css';

export function Menu() {
  return (
    <nav>
      <ul className={styles['list']}>
        <MenuItemLink to="catalog" text="Каталог проектов" />
        <MenuItemLink to="mortgage" text="Ипотека" />
        <MenuItemLink to="online-purchase" text="Онлайн покупка" />
        <MenuItemLink to="pikstandart" text="Надёжно" tabs={{ pikstandard: 'reliably' }} />
        <MenuItemLink to="pikstandart" text="ПИК-стандарт" tabs={{ pikstandard: 'standard' }} />
        <MenuItemLink to="pikstandart" text="ПИК — детям" tabs={{ pikstandard: 'children' }} />
        <MenuItemLink to="pikstandart" text="Что такое дом?" tabs={{ pikstandard: 'home' }} />
        <MenuItemLink to="offices" text="Жилые комплексы" />
        <MenuItemLink to="about" text="О компании" />
      </ul>
    </nav>
  );
}
